import React from 'react';

import './style.css';

const Tag = ({ text, color, ...otherProps }) => {
  return (
    <div
      className={`tag-conatiner ${color === 'green' ? 'tag-green' : ''} ${
        color === 'red' ? 'tag-red' : ''
      }`}
      {...otherProps}>
      <span>{text}</span>
    </div>
  );
};

Tag.defaultProps = {
  color: 'green'
};

export default Tag;



// WEBPACK FOOTER //
// ./src/Components/Tag/index.js